<template>
  <div id="app-div" style="overflow-y: hidden">
    <div class="top">
      <div class="search_icon">
        <span style="margin-left: 10px">
          <img src="../../../assets/u3220.png" class="icon_img" />
          筛选查询
        </span>
      </div>
      <div class="query_div">
        <a-row>
          <a-col :span="5">
            <label>日志类型：</label>
            <a-select v-model="search.type" placeholder="请选择" class="query_input">
              <a-select-option value="">全部</a-select-option>
              <a-select-option value="新增">新增</a-select-option>
              <a-select-option value="修改">修改</a-select-option>
              <a-select-option value="删除">删除</a-select-option>
              <a-select-option value="修改状态">修改状态</a-select-option>
              <a-select-option value="其他">其他</a-select-option>
            </a-select>
          </a-col>
          <a-col :span="5">
            <label>操作人：</label>
            <a-input placeholder="请输入" v-model="search.operateUser" class="query_input" />
          </a-col>
          <a-col :span="5">
            <label>标题：</label>
            <a-input placeholder="请输入" v-model="search.title" class="query_input" />
          </a-col>
          <a-col :span="6">
            <label>操作时间：</label>
            <a-range-picker @change="onTimeChange" class="query_input" />
          </a-col>
          <a-button type="primary" class="query_btn" @click="query"> 查询 </a-button>
        </a-row>
      </div>
    </div>
    <div class="middle">
      <div style="float: left; margin-left: 10px">
        <img src="../../../assets/u3227.png" class="icon_img" />
        <span>&nbsp;数据列表</span>
      </div>
      <div class="sortType" style="float: right">
        排序方式：
        <a-select size="small" defaultValue="3" style="width: 120px" @change="sortChange" v-model="sort">
          <a-select-option value="3">时间降序</a-select-option>
        </a-select>
      </div>
    </div>
    <div class="bottom" id="bottom">
      <div class="table_box">
        <a-table
          :pagination="false"
          :columns="columns"
          :dataSource="data"
          :rowKey="record => record.id"
          size="small"
          :scroll="{ y: data.length < 8 ? false : table_height }"
          bordered
        >
        </a-table>
      </div>
      <div id="components-pagination-demo-mini">
        <a-pagination
          :total="total"
          :showTotal="total => `共 ${total} 条`"
          showSizeChanger
          showQuickJumper
          :pageSizeOptions="pageSizeOptions"
          :defaultPageSize="limit"
          @showSizeChange="onShowSizeChange"
          @change="pageChange"
        />
      </div>
      <a-select defaultValue="0" class="batch_operation" @change="operateChange" v-model="operateCode">
        <a-select-option value="0">批量操作</a-select-option>
      </a-select>
    </div>
  </div>
</template>

<script>
var _this;
const columns = [
  {
    key: "index",
    align: "center",
    title: "序号",
    width: 70,
    customRender: (text, record, index) => {
      return (_this.page - 1) * _this.limit + index + 1;
    },
  },
  {
    dataIndex: "title",
    align: "center",
    title: "标题",
    width: 160,
  },
  {
    dataIndex: "operateUser",
    align: "center",
    title: "操作人",
    width: 90,
  },
  {
    dataIndex: "type",
    align: "center",
    title: "日志类型",
    width: 100,
  },
  {
    dataIndex: "operateTime",
    align: "center",
    title: "操作时间",
    width: 160,
  },
  {
    dataIndex: "detail",
    align: "center",
    title: "详情",
  },
];

import qs from "qs";
export default {
  name: "LoginfoList",
  data() {
    return {
      search: {},
      data: [],
      columns,
      sort: "3",
      sortField: "operate_time",
      sortType: "desc",
      userType: 2,
      operateCode: "0",
      page: 1,
      limit: 20,
      total: 0,
      pageSizeOptions: ["10", "20", "30", "40", "50"],
      table_height: 0,
    };
  },
  computed: {},
  created() {
    _this = this;
    _this.query();
  },
  mounted() {
    //设置bottom高度
    var height = document.body.clientHeight;
    var bottom_height = height - 230;
    var bottom = document.getElementById("bottom");
    bottom.style.height = bottom_height + "px";
    _this.table_height = bottom_height - 100;
  },
  methods: {
    onShowSizeChange(current, pageSize) {
      _this.page = current;
      _this.limit = pageSize;
      _this.query();
    },
    pageChange(pageNumber) {
      _this.page = pageNumber;
      _this.query();
    },
    onTimeChange(date, dateString) {
      _this.search.startTime = dateString[0] + " 00:00:00";
      _this.search.endTime = dateString[1] + " 23:59:59";
    },
    query() {
      this.axios
        .get("/admin/api/loginfo/getPageList", {
          params: {
            ...this.search,
            sortField: this.sortField,
            sortType: this.sortType,
            page: this.page,
            limit: this.limit,
            time: new Date().getTime(),
          },
          paramsSerializer: function (p) {
            return qs.stringify(p, { arrayFormat: "repeat" });
          },
        })
        .then(res => {
          if (res.data.code == "0") {
            this.total = res.data.count;
            this.data = res.data.data;
          } else {
            this.utils.messageInfo(this, "error", "查询用户列表失败！");
          }
        });
    },
    sortChange() {
      if (this.sort == 3) {
        this.sortField = "create_time";
        this.sortType = "desc";
      }
      this.query();
    },
    operateChange() {},
  },
};
</script>
<style>
@import "../../../assets/css/PageCss.css";
</style>
<style scoped>
.user-edit .ant-row {
  margin-bottom: 10px;
}
.user-edit .title {
  text-align: right;
  line-height: 32px;
}
.status_col {
  margin-top: 5px;
}
.status_img {
  width: 18px;
  margin-right: 6px;
  margin-bottom: 3px;
}
</style>
